import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import Modal from 'react-modal';
import Utils from 'medscape/utils';
import Helpers from 'infosite/helpers';
import ZoomLayerActions from './actions';
import ZoomLayerStore from './store';
import ZoomContent from './zoom-content';
export default class ZoomLayer extends Reflux.Component {
  constructor(props){
    super(props);
    this.state = {}
    this.store = ZoomLayerStore;
  }
  componentDidMount(){
    //let $this = $(ReactDOM.findDOMNode(this));
  }
  componentWillUpdate(nextProps,nextState){

  }
  componentDidUpdate(){
    let $this = $(ReactDOM.findDOMNode(this));
    if(this.state.modalIsOpen){
      Helpers.lockScroll("zoom-images-modal");
    }
    else{
      Helpers.unlockScroll("zoom-images-modal");
    }
  }
  componentWillUnmount(){  

  }
  onAfterOpen(){

  }
  doClose(e){
    ZoomLayerActions.close(e);
  }
  render() {
    const customStyles = {
      content : {
        //top: 20
      },
      overlay:{
        backgroundColor: 'none'
        //position: 'absolute',
        //height: $document.height()
      }
    };
    let modalProps = {
          key: 'zoom-layer',
          isOpen: this.state.modalIsOpen && this.state.settings!=null,
          onAfterOpen: this.onAfterOpen,
          onRequestClose: ZoomLayerActions.close,
          shouldCloseOnOverlayClick: false,
          className: "zoom-images-modal",
          contentLabel: "Zoom Images Modal",
          style: customStyles
    }
    return (
        <Modal {...modalProps}>
          <ZoomContent {...this.state.settings} onClose={this.doClose}/>
        </Modal>
    );
  } // render

}

ZoomLayer.propTypes={

}
ZoomLayer.defaultProps=  {
}



// WEBPACK FOOTER //
// ./src/app/zoom-images/zoom-layer/app.jsx